import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import IosInstruction from '@/themes/themeOne/iosInstruction/iosInstruction.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'iosInstruction',
  emits: ['closeInstructions'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const closeInstructions = () => {
    emit('closeInstructions');
    console.log('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(IosInstruction, { onCloseInstructions: closeInstructions })
  ]))
}
}

})